"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var Heading = function Heading(props) {
  var type = props.type,
      dataTestId = props.dataTestId,
      text = props.text,
      inline = props.inline;

  if (type < 1 || type > 6) {
    throw new Error("Invalid type ".concat(type, " provided to Heading."));
  }

  var Tag = inline ? "span" : "h".concat(type);
  var headingClass = inline ? "oui-h".concat(type) : null;
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, headingClass)
  }, text);
};

Heading.propTypes = {
  type: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  inline: _propTypes["default"].bool,
  text: _propTypes["default"].string.isRequired,
  dataTestId: _propTypes["default"].string
};
Heading.defaultProps = {
  type: "6",
  inline: false,
  dataTestId: "orion-heading"
};
Heading.displayName = "OrionHeading";
var _default = Heading;
exports["default"] = _default;